import { useCallback } from "react";
import { Bill, BillStatus } from "@common/types/bill";
import { useUpdateBill } from "@api/bill.api";

interface UpdateBillStatusParams {
    status: BillStatus;
    paidAt?: string | null;
}

interface UseBillDetailsHandlersParams {
    workspaceId: string | null | undefined;
    bill: Bill | undefined;
    setBill: (bill: Bill) => void;
}

export const useBillDetailsHandlers = ({
    workspaceId,
    bill,
    setBill,
}: UseBillDetailsHandlersParams) => {
    const { mutateAsync: updateBill } = useUpdateBill();

    const handleUpdateMemo = useCallback(
        async (memo: string | null) => {
            if (!workspaceId || !bill) {
                return;
            }
            await updateBill({ workspaceId, billId: bill.id, memo });
        },
        [workspaceId, bill, updateBill],
    );

    const handleUpdateStatus = useCallback(
        async ({ status, paidAt }: UpdateBillStatusParams) => {
            if (!workspaceId || !bill) {
                return;
            }
            await updateBill({
                workspaceId,
                billId: bill.id,
                status,
                paidAt,
            });
            setBill({
                ...bill,
                status,
                ...(paidAt !== undefined && {
                    paidAt: paidAt ? new Date(paidAt) : null,
                }),
            });
        },
        [workspaceId, bill, setBill, updateBill],
    );

    return { handleUpdateMemo, handleUpdateStatus };
};
